import React from 'react';
import SSE from 'services/sse';

export const PushContext = React.createContext<{ eventSource: SSE } | undefined>(undefined);

export default PushContext;
